
export class NPCResponse {
    public text: string;
    public isCorrect: boolean;

    constructor(text: string, isCorrect: boolean) {
        this.text = text;
        this.isCorrect = isCorrect;
    }
}

export class InterviewDialogue {
    public question: string;
    public responses: NPCResponse[];

    constructor(question: string, responses: NPCResponse[]) {
        this.question = question;
        this.responses = responses;
    }
}

export class Career {
    public id: string;
    public title: string;
    public boothText: string;
    public interviewDialog: InterviewDialogue[];

    constructor(id: string, title: string, boothText: string, interviewDialog: InterviewDialogue[]) {
        this.id = id;
        this.title = title;
        this.boothText = boothText;
        this.interviewDialog = interviewDialog;
    }

    /**
     * Using translation keys instead of strings
     */

    public static CAREERS: Career[] = [
        new Career("telemarketer", "CareerFair.Phaser.Careers.1.title",
            "CareerFair.Phaser.Careers.1.boothText",
            [
                new InterviewDialogue("CareerFair.Phaser.Careers.1.question1", [
                    new NPCResponse("CareerFair.Phaser.Careers.1.responses1.1", true),
                    new NPCResponse("CareerFair.Phaser.Careers.1.responses1.2", false),
                    new NPCResponse("CareerFair.Phaser.Careers.1.responses1.3", null),
                ]),
                new InterviewDialogue("CareerFair.Phaser.Careers.1.question2", [
                    new NPCResponse("CareerFair.Phaser.Careers.1.responses2.1", true),
                    new NPCResponse("CareerFair.Phaser.Careers.1.responses2.2", false),
                    new NPCResponse("CareerFair.Phaser.Careers.1.responses2.3", null),
                ]),
            ]
        ),
        new Career("it_project_manager", "CareerFair.Phaser.Careers.2.title",
            "CareerFair.Phaser.Careers.2.boothText",
            [
                new InterviewDialogue("CareerFair.Phaser.Careers.2.question1", [
                    new NPCResponse("CareerFair.Phaser.Careers.2.responses1.1", true),
                    new NPCResponse("CareerFair.Phaser.Careers.2.responses1.2", false),
                    new NPCResponse("CareerFair.Phaser.Careers.2.responses1.3", null),
                ]),
                new InterviewDialogue("CareerFair.Phaser.Careers.2.question2", [
                    new NPCResponse("CareerFair.Phaser.Careers.2.responses2.1", false),
                    new NPCResponse("CareerFair.Phaser.Careers.2.responses2.2", true),
                    new NPCResponse("CareerFair.Phaser.Careers.2.responses2.3", null),
                ]),
            ]
        ), new Career("public_relations", "CareerFair.Phaser.Careers.3.title",
            "CareerFair.Phaser.Careers.3.boothText",
            [
                new InterviewDialogue("CareerFair.Phaser.Careers.3.question1", [
                    new NPCResponse("CareerFair.Phaser.Careers.3.responses1.1", false),
                    new NPCResponse("CareerFair.Phaser.Careers.3.responses1.2", true),
                    new NPCResponse("CareerFair.Phaser.Careers.3.responses1.3", null),
                ]),
                new InterviewDialogue("CareerFair.Phaser.Careers.3.question2", [
                    new NPCResponse("CareerFair.Phaser.Careers.3.responses2.1", true),
                    new NPCResponse("CareerFair.Phaser.Careers.3.responses2.2", false),
                    new NPCResponse("CareerFair.Phaser.Careers.3.responses2.3", null),
                ]),
            ]
        ), new Career("construction_manager", "CareerFair.Phaser.Careers.4.title",
            "CareerFair.Phaser.Careers.4.boothText",
            [
                new InterviewDialogue("CareerFair.Phaser.Careers.4.question1", [
                    new NPCResponse("CareerFair.Phaser.Careers.4.responses1.1", true),
                    new NPCResponse("CareerFair.Phaser.Careers.4.responses1.2", false),
                    new NPCResponse("CareerFair.Phaser.Careers.4.responses1.3", null),
                ]),
                new InterviewDialogue("CareerFair.Phaser.Careers.4.question2", [
                    new NPCResponse("CareerFair.Phaser.Careers.4.responses2.1", false),
                    new NPCResponse("CareerFair.Phaser.Careers.4.responses2.2", true),
                    new NPCResponse("CareerFair.Phaser.Careers.4.responses2.3", null),
                ]),
            ]
        ),
    ];
}



// WEBPACK FOOTER //
// ./src/games/CareerFairGame/objects/Career.ts